export type InvoiceLockLike = {
  invoice_type?: string;
  invoice_status?: string;
};

export function isPrimaryInvoiceApproved(invoices: InvoiceLockLike[] | undefined): boolean {
  if (!invoices?.length) return false;
  return invoices.some(
    (invoice) => invoice.invoice_type === "primary_invoice" && invoice.invoice_status === "Approved",
  );
}
